module.exports = ".select-box{\r\n  width: auto;\r\n  margin: 0px 10px;\r\n}\r\n\r\n:host /deep/ .mat-checkbox-layout{\r\n  /*無理やり中央ぞろえ*/\r\n  margin-top: .5rem;\r\n}\r\n\r\nlabel.label-middle{\r\n  margin-top: .5rem;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0102-question-category/question-category.component.css
// module id = ./src/app/a0102-question-category/question-category.component.css
// module chunks = main